export default {
  0: 'PageDefault',
  1: 'PageDefaultList',
  2: 'PageDefaultSingle',
  3: 'PageDefault',
};
